var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1509.54 695.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #cf796b;\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 58.2,
    y1: 286.3,
    x2: 563.68,
    y2: 286.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#302c8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#302c8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#cf796b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf796b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 50.18,
    cy: 2294.97,
    fx: 50.18,
    fy: 2294.97,
    r: 59.91,
    gradientTransform: "translate(175.87 -374.83) scale(2.75 .44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#302c8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#36328e",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4d4a9b",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#8b89be",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#eeeef5",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1454.16,310.29c-4.73-19.45-16.49-32.94-36.16-35.44-18.23-2.32-35.62,4.73-44.99,22-6.96,12.84-8.68,26.54-5.51,40.71,4.02,17.97,14.94,29.89,32.62,35.21,10.9,3.28,22.03,2.92,33.11,.88,6.13-1.13,12.04-3.04,17.83-5.97-1.77-7.17-3.48-14.13-5.15-20.93-5.99,1.66-11.65,3.62-17.46,4.74-7.24,1.4-14.58,1.69-21.72-.98-8-2.99-14.19-11.94-13.59-19.87,.77-.06,1.56-.18,2.36-.18,19.18-.01,38.35-.01,57.53,0,.93,0,1.87,.23,2.8,.35v-13.89c-.55-2.22-1.12-4.43-1.66-6.65Zm-60.52,2.6c1.16-9.82,9.35-15.98,17.84-15.76,10.47,.28,16.54,5.17,18.11,15.76h-35.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1027.19,249.73c-8.02-4.88-16.84-6.84-26.07-6.97-12.11-.18-24.21-.05-36.32-.03-1.17,0-2.34,.16-3.5,.24v129.35h26.74v-47.21c4.24,0,7.92,.21,11.56-.05,5-.36,10.11-.55,14.93-1.76,14.77-3.69,25.17-12.4,29.42-27.51,1.69-5.99,1.83-12.15,1.06-18.23-1.52-12.02-7.34-21.44-17.83-27.82Zm-9.26,37.6c-1.23,8.86-5.23,13.1-14.11,14.18-5.06,.61-10.21,.53-15.57,.77v-35.96c4.83,0,9.32-.22,13.77,.04,11.39,.69,17.57,8.95,15.9,20.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1213.75,283.48c-2.77-1.79-5.04-3.52-7.53-4.82-16.46-8.65-38.08-3.76-49.98,11.26-10.12,12.78-13.43,27.43-11.22,43.33,1.63,11.72,6.39,22.09,15.01,30.51,14.25,13.92,38.85,15.34,52.82,2.66,.56-.51,1.25-.86,2.23-1.52,.63,2.69,1.17,5.02,1.76,7.51h23.07v-93.66c-8.68-.63-17.11-1.25-25.65-1.87-.19,2.46-.33,4.4-.5,6.59Zm1.44,47.69c-1.35,8.03-5.11,14.56-12.44,18.59-10.89,5.98-22.72,2.02-27.94-9.23-2.39-5.15-3.36-10.57-3.21-16.22-.09-4.95,.78-9.72,2.7-14.29,7.12-16.94,25.62-14.99,33.83-6.16,7.24,7.8,8.77,17.18,7.07,27.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M733.17,312.57c-2.12-10.89-6.54-20.67-14.97-28.33-15.36-13.96-48.93-15.16-64.82,9.55-7.7,11.97-10.06,25.25-8.13,39.11,2.65,19.06,12.75,32.57,31.25,39.17,8.9,3.18,18.12,3.47,27.38,2.7,8.84-.73,17.34-2.89,25.73-7.09-1.75-7.15-3.46-14.19-5.23-21.42-8.23,3.3-16.11,5.74-24.5,6.07-5.62,.22-11.15,0-16.31-2.6-7.74-3.88-11.11-10.54-12.45-19.31h64.23c-.75-6.34-1.08-12.18-2.19-17.86Zm-60.77,.4c.36-8.77,7.86-15.6,17.07-15.76,10.9-.19,17.73,5.53,18.54,15.76h-35.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M885.55,274.85c-19.2-2.45-36.74,5.32-45.72,23.42-7.55,15.23-8.42,31.1-2.46,47.06,4.28,11.46,12.22,19.78,23.38,24.89,6.76,3.09,13.89,4.57,21.31,4.82,12.68,.41,24.84-1.65,36.56-7.36-1.78-7.15-3.52-14.16-5.23-21.05-.71,0-.85-.04-.97,0-.89,.34-1.76,.71-2.65,1.04-9.52,3.6-19.29,5.62-29.52,4.38-11.3-1.37-19.48-10.15-19.79-21.62h63.22c.2-10.75-1.24-20.73-5.33-30.22-6.25-14.49-16.97-23.35-32.81-25.37Zm-24.55,38.05c2.3-11.55,10.36-16.19,19.37-15.76,9.38,.45,14.97,5.35,16.85,15.76h-36.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1320.73,352.36c-6.43,.43-8.93-1.9-9.59-8.28-.11-1.08-.18-2.17-.18-3.25-.01-14.15-.01-28.3,0-42.44,0-1.32,.13-2.65,.22-4.36h20.43v-17.25h-20.73v-25.4c-8.89,1.65-17.35,3.23-26.14,4.86v20.68h-11.68v17.12h11.69c0,2.02,0,3.5,0,4.98,0,13.33-.03,26.66,.02,40,.01,3.26,.15,6.53,.42,9.77,.99,12.05,8.09,20.89,19.61,24.4,7.42,2.26,15,2.39,22.61,1.25,3.56-.53,7.2-.99,10.61-2.93-1.49-7.13-2.94-14.1-4.38-20.99-4.64,.69-8.76,1.57-12.91,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M796.33,344.1c-.08-1.22-.03-2.45-.03-3.68,0-33.9,0-67.8,0-101.7,0-1.55-.09-3.1-.14-4.87-8.77,1.51-16.92,2.92-25.74,4.44v5.19c0,34.45,0,68.89,.02,103.34,0,2.31,.15,4.63,.43,6.92,1.75,14.41,16.14,24.12,30.71,20.55,.65-7.17,1.31-14.42,1.95-21.59-5.92-1.6-6.83-2.73-7.19-8.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1107.22,343.71c0-.95,0-1.91,0-2.86,0-34.04,0-68.07,0-102.11v-4.96c-8.96,1.56-17.37,3.02-25.8,4.48-.19,.91-.29,1.17-.29,1.43-.01,36.49-.08,72.97,.07,109.46,.02,3.72,.85,7.63,2.16,11.13,3.81,10.2,16.61,16.35,28.96,14.14,.64-7.2,1.29-14.48,1.93-21.66-6.15-1.84-6.97-2.95-7.02-9.05Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M497.48,102.48c-49.1-49.1-114.38-76.14-183.81-76.14s-134.72,27.04-183.81,76.14c-49.1,49.1-76.14,114.38-76.14,183.81s27.04,134.72,76.14,183.81c49.1,49.1,114.38,76.14,183.81,76.14s134.72-27.04,183.81-76.14c49.1-49.1,76.14-114.38,76.14-183.81s-27.04-134.72-76.14-183.81Zm-21.12,346.51c-43.46,43.46-101.24,67.39-162.69,67.39s-119.24-23.93-162.69-67.39c-43.46-43.46-67.39-101.24-67.39-162.69s23.93-119.24,67.39-162.69c43.46-43.46,101.24-67.39,162.69-67.39s119.24,23.93,162.69,67.39c43.46,43.46,67.39,101.24,67.39,162.69s-23.93,119.24-67.39,162.69Zm-95.26-3.56c-21.05,8.92-43.88,13.61-67.43,13.61-46.14,0-89.52-17.97-122.14-50.59-32.63-32.63-50.59-76-50.59-122.14,0-28.48,6.85-55.92,19.77-80.42,6.51,.4,19.85,2.88,25.4,16.13-9.79,19.34-15.3,41.19-15.3,64.29,0,78.78,64.09,142.87,142.87,142.87,17.39,0,34.07-3.13,49.51-8.85,5.31,1.25,19.52,6.36,17.92,25.11Zm105.31-159.13c0,25.23-5.37,49.63-15.57,71.9-17.81,1.82-23.63-10.29-25.44-16.57,7.18-17.02,11.15-35.72,11.15-55.33,0-78.78-64.09-142.87-142.87-142.87-17.27,0-33.83,3.08-49.16,8.72h0c-11.12-3.05-11.96-19.23-11.62-27.63,19.18-7.2,39.7-10.96,60.8-10.96,46.14,0,89.52,17.97,122.14,50.59s50.59,76.01,50.59,122.14Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 313.67,
    cy: 642.73,
    rx: 164.53,
    ry: 26.56
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRight);
export default __webpack_public_path__ + "static/media/logo_right.9f6a8f3c541625a62d8781c3456896fe.svg";
export { ForwardRef as ReactComponent };